// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#root {
	height: 100vh;
}
#editor-container {
	height: 100%;
	overflow-x: hidden;
}
.small-text {
	font-size: 0.75rem;
}

.toolbar-button {
	aspect-ratio: 1;
    background-color: #e5deff;
    color: #7d59ff;
    border-radius: 10px;
    display: inline-flex;
    flex-direction: column;
	justify-content: center;
	width: 100%;
	height: 100%;
	max-width: 70px;
	max-height: 70px;
    font-size: 35px;
    text-align: center;
    cursor: pointer;
}


.toolbar-button i {
	max-height: 100%;
	width: 100%;
	object-fit: contain;
}

.custom-button-outline {
	display: flex !important;
	gap: .5rem !important;
	align-items: center !important;
	border: 1px solid #7d59ff !important;
	border-radius: 20px !important;
	color: #7d59ff !important;
  }

  .custom-button {
	display: flex !important;
	gap: .5rem !important;
	align-items: center !important;
	border-radius: 20px !important;
	color: white !important;
	background-color: #7d59ff !important;
  }

  .custom-button-outline.btn-lg {
	border-radius: 30px !important;
  }

  .custom-button-outline:hover {
	background-color: #dfe3ff !important;
  }

  .custom-button:hover {
	background-color: #6648ce !important;
  }

  .custom-button-outline:active {
	box-shadow: inset 0 4px 8px rgba(0, 0, 0, 0.2) !important;
	background-color: #fff !important;
	fill: #585454;
}

.custom-textarea {
	width: 100%;
	min-height: 60px;
	padding: 6px 12px;
	margin: 10px 0;
	font-size: 14px;
	border-radius: 20px;
	border: 1px solid #ccc;
	box-shadow: inset 0 1px 1px rgba(0, 0, 0, .075), 0 0 0 0 rgba(21, 218, 182, .6);
	transition: border-color ease-in-out .15s,box-shadow ease-in-out .15s;
}

.custom-textarea:focus {
	outline: none;
	border: 1px solid #15dab6;
	box-shadow: inset 0 1px 1px rgba(0, 0, 0, .075), 0 0 8px 0 rgba(21, 218, 182, .6);
	transition: border-color ease-in-out .15s,box-shadow ease-in-out .15s;
}


@media (max-width: 575px) {
	.toolbar-button {
		max-width: 60px;
		max-height: 60px;
		width: 60px;
		height: 60px;
		padding: 5px 10px;
		font-size: 28px;
	}
	
	.small-text {
		font-size: 0.45rem;
	}
}

@media (max-width: 374px) {
	#global-container {
		width: 300px;
	}
}

@media (min-width: 375px ) and (max-width: 424px) {
	#global-container {
		width: 375px;
	}
}

@media (min-width: 425px ) and (max-width: 474px) {
	#global-container {
		width: 425px;
	}
}

@media (min-width: 475px ) and (max-width: 524px) {
	#global-container {
		width: 475px;
	}
}

@media (min-width: 525px ) and (max-width: 574px) {
	#global-container {
		width: 525px;
	}
}

@media (min-width: 575px ) and (max-width: 674px) {
	#global-container {
		width: 575px;
    }
}

@media (min-width: 675px ) and (max-width: 767px) {
	#global-container {
		width: 675px;
		max-width: 675px !important;
    }
}

@media (min-width: 768px ) and (max-width: 849px) {
	#global-container {
		width: 620px;
    }
}

@media (min-width: 850px ) and (max-width: 991px) {
	#global-container {
		width: 768px;
    }
}

@media (min-width: 992px ) and (max-width: 1199px) {
	#global-container {
		width: 842px;
    }
}

@media (min-width: 1200px) {
	#global-container {
		width: 1050px;
    }
}

@media (max-height: 374px) {
	#global-container {
		height: 300px;
	}
}

@media (min-height: 375px ) and (max-height: 424px) {
	#global-container {
		height: 295px;
	}
}

@media (min-height: 425px ) and (max-height: 474px) {
	#global-container {
		height: 345px;
	}
}

@media (min-height: 475px ) and (max-height: 524px) {
	#global-container {
		height: 375px;
	}
}

@media (min-height: 525px ) and (max-height: 574px) {
	#global-container {
		height: 425px;
	}
}

@media (min-height: 575px ) and (max-height: 674px) {
	#global-container {
		height: 475px;
    }
}

@media (min-height: 675px ) and (max-height: 774px) {
	#global-container {
		height: 575px;
    }
}

@media (min-height: 775px ) and (max-height: 849px) {
	#global-container {
		height: 675px;
    }
}

@media (min-height: 850px) {
	#global-container {
		height: 750px;
    }
}

@media (min-width: 768px) {
	#capture {
		width: 100%;
		height: 100%;
	}
  }

@media (min-width: 576px) {
	.h-sm-100 {
	  height: 100% !important;
	}
  }

.spinner-animation {
	animation: spin 3s linear infinite;
}

@keyframes spin {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(360deg);
	}
}


canvas {
	box-shadow: 0 4px 36px rgb(0 0 0 / 13%);
}`, "",{"version":3,"sources":["webpack://./src/assets/style/custom.css"],"names":[],"mappings":"AAAA;CACC,aAAa;AACd;AACA;CACC,YAAY;CACZ,kBAAkB;AACnB;AACA;CACC,kBAAkB;AACnB;;AAEA;CACC,eAAe;IACZ,yBAAyB;IACzB,cAAc;IACd,mBAAmB;IACnB,oBAAoB;IACpB,sBAAsB;CACzB,uBAAuB;CACvB,WAAW;CACX,YAAY;CACZ,eAAe;CACf,gBAAgB;IACb,eAAe;IACf,kBAAkB;IAClB,eAAe;AACnB;;;AAGA;CACC,gBAAgB;CAChB,WAAW;CACX,mBAAmB;AACpB;;AAEA;CACC,wBAAwB;CACxB,qBAAqB;CACrB,8BAA8B;CAC9B,oCAAoC;CACpC,8BAA8B;CAC9B,yBAAyB;EACxB;;EAEA;CACD,wBAAwB;CACxB,qBAAqB;CACrB,8BAA8B;CAC9B,8BAA8B;CAC9B,uBAAuB;CACvB,oCAAoC;EACnC;;EAEA;CACD,8BAA8B;EAC7B;;EAEA;CACD,oCAAoC;EACnC;;EAEA;CACD,oCAAoC;EACnC;;EAEA;CACD,yDAAyD;CACzD,iCAAiC;CACjC,aAAa;AACd;;AAEA;CACC,WAAW;CACX,gBAAgB;CAChB,iBAAiB;CACjB,cAAc;CACd,eAAe;CACf,mBAAmB;CACnB,sBAAsB;CACtB,+EAA+E;CAC/E,qEAAqE;AACtE;;AAEA;CACC,aAAa;CACb,yBAAyB;CACzB,iFAAiF;CACjF,qEAAqE;AACtE;;;AAGA;CACC;EACC,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,eAAe;CAChB;;CAEA;EACC,kBAAkB;CACnB;AACD;;AAEA;CACC;EACC,YAAY;CACb;AACD;;AAEA;CACC;EACC,YAAY;CACb;AACD;;AAEA;CACC;EACC,YAAY;CACb;AACD;;AAEA;CACC;EACC,YAAY;CACb;AACD;;AAEA;CACC;EACC,YAAY;CACb;AACD;;AAEA;CACC;EACC,YAAY;IACV;AACJ;;AAEA;CACC;EACC,YAAY;EACZ,2BAA2B;IACzB;AACJ;;AAEA;CACC;EACC,YAAY;IACV;AACJ;;AAEA;CACC;EACC,YAAY;IACV;AACJ;;AAEA;CACC;EACC,YAAY;IACV;AACJ;;AAEA;CACC;EACC,aAAa;IACX;AACJ;;AAEA;CACC;EACC,aAAa;CACd;AACD;;AAEA;CACC;EACC,aAAa;CACd;AACD;;AAEA;CACC;EACC,aAAa;CACd;AACD;;AAEA;CACC;EACC,aAAa;CACd;AACD;;AAEA;CACC;EACC,aAAa;CACd;AACD;;AAEA;CACC;EACC,aAAa;IACX;AACJ;;AAEA;CACC;EACC,aAAa;IACX;AACJ;;AAEA;CACC;EACC,aAAa;IACX;AACJ;;AAEA;CACC;EACC,aAAa;IACX;AACJ;;AAEA;CACC;EACC,WAAW;EACX,YAAY;CACb;EACC;;AAEF;CACC;GACE,uBAAuB;CACzB;EACC;;AAEF;CACC,kCAAkC;AACnC;;AAEA;CACC;EACC,uBAAuB;CACxB;CACA;EACC,yBAAyB;CAC1B;AACD;;;AAGA;CACC,uCAAuC;AACxC","sourcesContent":["#root {\n\theight: 100vh;\n}\n#editor-container {\n\theight: 100%;\n\toverflow-x: hidden;\n}\n.small-text {\n\tfont-size: 0.75rem;\n}\n\n.toolbar-button {\n\taspect-ratio: 1;\n    background-color: #e5deff;\n    color: #7d59ff;\n    border-radius: 10px;\n    display: inline-flex;\n    flex-direction: column;\n\tjustify-content: center;\n\twidth: 100%;\n\theight: 100%;\n\tmax-width: 70px;\n\tmax-height: 70px;\n    font-size: 35px;\n    text-align: center;\n    cursor: pointer;\n}\n\n\n.toolbar-button i {\n\tmax-height: 100%;\n\twidth: 100%;\n\tobject-fit: contain;\n}\n\n.custom-button-outline {\n\tdisplay: flex !important;\n\tgap: .5rem !important;\n\talign-items: center !important;\n\tborder: 1px solid #7d59ff !important;\n\tborder-radius: 20px !important;\n\tcolor: #7d59ff !important;\n  }\n\n  .custom-button {\n\tdisplay: flex !important;\n\tgap: .5rem !important;\n\talign-items: center !important;\n\tborder-radius: 20px !important;\n\tcolor: white !important;\n\tbackground-color: #7d59ff !important;\n  }\n\n  .custom-button-outline.btn-lg {\n\tborder-radius: 30px !important;\n  }\n\n  .custom-button-outline:hover {\n\tbackground-color: #dfe3ff !important;\n  }\n\n  .custom-button:hover {\n\tbackground-color: #6648ce !important;\n  }\n\n  .custom-button-outline:active {\n\tbox-shadow: inset 0 4px 8px rgba(0, 0, 0, 0.2) !important;\n\tbackground-color: #fff !important;\n\tfill: #585454;\n}\n\n.custom-textarea {\n\twidth: 100%;\n\tmin-height: 60px;\n\tpadding: 6px 12px;\n\tmargin: 10px 0;\n\tfont-size: 14px;\n\tborder-radius: 20px;\n\tborder: 1px solid #ccc;\n\tbox-shadow: inset 0 1px 1px rgba(0, 0, 0, .075), 0 0 0 0 rgba(21, 218, 182, .6);\n\ttransition: border-color ease-in-out .15s,box-shadow ease-in-out .15s;\n}\n\n.custom-textarea:focus {\n\toutline: none;\n\tborder: 1px solid #15dab6;\n\tbox-shadow: inset 0 1px 1px rgba(0, 0, 0, .075), 0 0 8px 0 rgba(21, 218, 182, .6);\n\ttransition: border-color ease-in-out .15s,box-shadow ease-in-out .15s;\n}\n\n\n@media (max-width: 575px) {\n\t.toolbar-button {\n\t\tmax-width: 60px;\n\t\tmax-height: 60px;\n\t\twidth: 60px;\n\t\theight: 60px;\n\t\tpadding: 5px 10px;\n\t\tfont-size: 28px;\n\t}\n\t\n\t.small-text {\n\t\tfont-size: 0.45rem;\n\t}\n}\n\n@media (max-width: 374px) {\n\t#global-container {\n\t\twidth: 300px;\n\t}\n}\n\n@media (min-width: 375px ) and (max-width: 424px) {\n\t#global-container {\n\t\twidth: 375px;\n\t}\n}\n\n@media (min-width: 425px ) and (max-width: 474px) {\n\t#global-container {\n\t\twidth: 425px;\n\t}\n}\n\n@media (min-width: 475px ) and (max-width: 524px) {\n\t#global-container {\n\t\twidth: 475px;\n\t}\n}\n\n@media (min-width: 525px ) and (max-width: 574px) {\n\t#global-container {\n\t\twidth: 525px;\n\t}\n}\n\n@media (min-width: 575px ) and (max-width: 674px) {\n\t#global-container {\n\t\twidth: 575px;\n    }\n}\n\n@media (min-width: 675px ) and (max-width: 767px) {\n\t#global-container {\n\t\twidth: 675px;\n\t\tmax-width: 675px !important;\n    }\n}\n\n@media (min-width: 768px ) and (max-width: 849px) {\n\t#global-container {\n\t\twidth: 620px;\n    }\n}\n\n@media (min-width: 850px ) and (max-width: 991px) {\n\t#global-container {\n\t\twidth: 768px;\n    }\n}\n\n@media (min-width: 992px ) and (max-width: 1199px) {\n\t#global-container {\n\t\twidth: 842px;\n    }\n}\n\n@media (min-width: 1200px) {\n\t#global-container {\n\t\twidth: 1050px;\n    }\n}\n\n@media (max-height: 374px) {\n\t#global-container {\n\t\theight: 300px;\n\t}\n}\n\n@media (min-height: 375px ) and (max-height: 424px) {\n\t#global-container {\n\t\theight: 295px;\n\t}\n}\n\n@media (min-height: 425px ) and (max-height: 474px) {\n\t#global-container {\n\t\theight: 345px;\n\t}\n}\n\n@media (min-height: 475px ) and (max-height: 524px) {\n\t#global-container {\n\t\theight: 375px;\n\t}\n}\n\n@media (min-height: 525px ) and (max-height: 574px) {\n\t#global-container {\n\t\theight: 425px;\n\t}\n}\n\n@media (min-height: 575px ) and (max-height: 674px) {\n\t#global-container {\n\t\theight: 475px;\n    }\n}\n\n@media (min-height: 675px ) and (max-height: 774px) {\n\t#global-container {\n\t\theight: 575px;\n    }\n}\n\n@media (min-height: 775px ) and (max-height: 849px) {\n\t#global-container {\n\t\theight: 675px;\n    }\n}\n\n@media (min-height: 850px) {\n\t#global-container {\n\t\theight: 750px;\n    }\n}\n\n@media (min-width: 768px) {\n\t#capture {\n\t\twidth: 100%;\n\t\theight: 100%;\n\t}\n  }\n\n@media (min-width: 576px) {\n\t.h-sm-100 {\n\t  height: 100% !important;\n\t}\n  }\n\n.spinner-animation {\n\tanimation: spin 3s linear infinite;\n}\n\n@keyframes spin {\n\tfrom {\n\t\ttransform: rotate(0deg);\n\t}\n\tto {\n\t\ttransform: rotate(360deg);\n\t}\n}\n\n\ncanvas {\n\tbox-shadow: 0 4px 36px rgb(0 0 0 / 13%);\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
